<div class="question-type__text">
  <h1 class="fs__xxl">Carousel</h1>
  <p class="fs__md">
    Use this question type if you want to ask the same question about multiple different subjects. For each topic, the participant will be present a list of
    options they can pick from.
  </p>
  <h2 class="fs__lg">Best Practices</h2>
  <ul class="question-type__bullet-points">
    <li class="fs__sm">
      <span class="text fw__500">Generic Question</span>
      <span class="sub-text">Ensure your question is suitable to be used for each subject of the carousel.</span>
    </li>
  </ul>
</div>
